import DamageBodySvg, { HITGROUPS, type HitgroupValues } from './DamageBodySvg';

type DamageHitgroupMapProps = {
  label: string;
  shots: HitgroupValues;
  damage: HitgroupValues;
  totalShots: number;
  totalDamage: number;
  baseColor: string;
  toneClass: string;
};

const buildFill = (value: number, maxValue: number, baseColor: string) => {
  const intensity = maxValue > 0 ? value / maxValue : 0;
  const alpha = 0.2 + intensity * 0.8;
  return `rgba(${baseColor}, ${alpha.toFixed(2)})`;
};

export default function DamageHitgroupMap({
  label,
  shots,
  damage,
  totalShots,
  totalDamage,
  baseColor,
  toneClass,
}: DamageHitgroupMapProps) {
  const maxValue = Math.max(...Object.values(shots), 1);

  return (
    <div className="grid gap-4 min-[960px]:grid-cols-[minmax(0,1fr)_220px]">
      <div className="rounded-2xl border border-stroke bg-[rgba(31,13,26,0.6)] p-4">
        <div className="flex flex-col items-center justify-between gap-3">
          <span
            className={`rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[1px] ${toneClass}`}
          >
            {label}
          </span>
          <div className="text-right text-[12px] text-muted">
            <div>Total {Math.round(totalShots)} shots</div>
            <div className="text-[11px]">Damage {Math.round(totalDamage)} dmg</div>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-center">
          <DamageBodySvg values={shots} maxValue={maxValue} baseColor={baseColor} />
        </div>
      </div>
      <div className="grid gap-2.5">
        {HITGROUPS.map(({ key, label: groupLabel }) => {
          const shotCount = shots[key];
          const damageAmount = damage[key];
          const percent = totalShots > 0 ? Math.round((shotCount / totalShots) * 100) : 0;
          const barColor = buildFill(shotCount, maxValue, baseColor);

          return (
            <div
              className="rounded-xl border border-stroke bg-[rgba(53,25,44,0.6)] px-3 py-2"
              key={key}
            >
              <div className="flex items-center justify-between text-[12px]">
                <span className="uppercase tracking-[1px] text-muted">{groupLabel}</span>
                <span className="text-ink">{Math.round(shotCount)} shots <span className="text-muted">({Math.round(damageAmount)} dmg)</span></span>
                
              </div>
              <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-[rgba(60,27,46,0.7)]">
                <div
                  className="h-full rounded-full"
                  style={{ width: `${percent}%`, backgroundColor: barColor }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
